export enum RoleSEnums {
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  TECHNICAL = 'TECHNICAL',
  GUEST = 'GUEST',
  CLIENT = 'CLIENT'
}
